import tags from "../../../components/tags";
import { icons, note } from "../../../components/html";
import { statusCodes } from "../../../components/responses";

export default {
  "/visitor/size-recommendation/{id}": {
    get: {
      tags: [tags.sizeIdAccount],
      summary: "Size recommendation for visitor",
      description: `${icons.c}
      Based on size chart specified with path parameter returns recommended size of visitor identified by his email or CWID.
${note(
  "For successful recommendation it is necessary for the client to have the chart added to its active one."
)}`,

      parameters: [
        { $ref: "#/components/parameters/acceptsLanguages" },
        { $ref: "#/components/parameters/userEmailIdentifier" },
        { $ref: "#/components/parameters/cwid" },
        { $ref: "#/components/parameters/tableId" }
      ],

      responses: {
        "200": {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/recommendedSize"
              }
            }
          }
        },
        ...statusCodes
      }
    }
  }
};
